import React from 'react';
import { UserCheck, FileSignature, Shield, Receipt } from 'lucide-react';
import { LIFECYCLE_STEPS } from '../data/demoContent';

const iconMap = {
  UserCheck: UserCheck,
  FileSignature: FileSignature,
  Shield: Shield,
  Receipt: Receipt
};

const DemoLifecycle = () => {
  return (
    <section className="erp-section-container-light" id="lifecycle">
      <div className="jp-workspace-container">
        <div className="erp-clean-header">
          <div className="erp-clean-badge">
            <span>Unified Architecture</span>
          </div>
          <h2 className="erp-clean-title">
            How Prophecy Nexus Connects in 4 Simple Steps
          </h2>
          <p className="erp-clean-desc">
            Instead of running operations across disconnected emails and spreadsheets, Prophecy Nexus connects every department in one continuous, automated flow.
          </p>
        </div>

        <div className="erp-lifecycle-grid-white">
          {LIFECYCLE_STEPS.map((step) => {
            const IconComponent = iconMap[step.icon] || UserCheck;
            return (
              <div key={step.step} className="erp-lifecycle-card-white">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <span className="erp-step-number-pill">STEP {step.step}</span>
                  <div
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '8px',
                      background: '#eff6ff',
                      border: '1px solid #bfdbfe',
                      color: '#2563eb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <IconComponent size={18} />
                  </div>
                </div>

                <h3 style={{ fontSize: '17px', fontWeight: '800', color: '#0f172a', margin: '0 0 8px 0' }}>
                  {step.title}
                </h3>
                <p style={{ fontSize: '13px', color: '#475569', lineHeight: '1.6', margin: 0 }}>
                  {step.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DemoLifecycle;
